import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import { Link } from 'react-router';
import classNames from 'classnames';
import { NATION_WATCH_FREE } from 'helpers/ContentHelper';
import ReadMore from 'components/ReadMore';
import { SegmentUiElements } from '@foxcorp/delta-web-analytics';

const Subtitle = props => {
  const {
    account,
    freemiumOverride,
    link,
    isDisabled,
    isFreemiumOverride,
    isRedirect,
    name,
    onTileClick,
    originalItem,
    percentWatched,
    recommendationIdData,
    subtitle,
    subtitleLines,
    subtitleText: subtitleTextProp,
    target,
    titleText,
    theme,
    truncateSubtitle,
  } = props;
  let subtitleLink = link;
  const subTitleClasses = [theme.subtitle];
  if (!subtitle || subtitle.length === 0) return null;
  let subtitleText;
  if (truncateSubtitle) {
    subtitleText = (
      <ReadMore moreText="More" lessText="Less" lines={subtitleLines || 2} theme={theme}>
        {subtitle}
      </ReadMore>
    );
  } else {
    subtitleText = subtitleLines ? (
      <Dotdotdot clamp={subtitleLines}>{subtitle}</Dotdotdot>
    ) : (
      subtitle
    );
  }
  if (!link || truncateSubtitle || isDisabled) {
    return <div className={classNames([theme.subtitle, theme.disabled])}>{subtitleText}</div>;
  }
  if (isRedirect || isFreemiumOverride) {
    subtitleLink = null;
    subTitleClasses.push(theme.redirectLink);
  }
  const onClick = () => {
    if (onTileClick && !isFreemiumOverride) {
      onTileClick({
        originalItem,
        name,
        percentWatched,
        account,
        recommendationIdData,
        subtitleText: subtitleTextProp,
        titleText,
        uiElement: SegmentUiElements.SERIES_EPISODE,
      });
    } else if (isFreemiumOverride) {
      freemiumOverride();
    }
  };

  if (originalItem?.['@id']?.includes(NATION_WATCH_FREE)) {
    subTitleClasses.push(theme.nationWatchFree);
  }

  function linkHander(e) {
    onClick(e);
  }

  return (
    <Link
      onClick={linkHander}
      to={subtitleLink}
      target={target}
      className={classNames(subTitleClasses)}
      aria-live="off"
      aria-hidden="true"
    >
      {subtitleText}
    </Link>
  );
};

Subtitle.defaultProps = {
  account: null,
  isDisabled: false,
  isRedirect: false,
  link: null,
  name: null,
  onTileClick: null,
  originalItem: {},
  percentWatched: null,
  recommendationIdData: null,
  subtitle: null,
  subtitleLines: null,
  subtitleText: null,
  target: null,
  theme: {},
  titleText: null,
  truncateSubtitle: null,
};

Subtitle.propTypes = {
  account: PropTypes.shape({}),
  freemiumOverride: PropTypes.func,
  isDisabled: PropTypes.bool,
  isFreemiumOverride: PropTypes.bool,
  isRedirect: PropTypes.bool,
  link: PropTypes.string,
  name: PropTypes.string,
  onTileClick: PropTypes.func,
  originalItem: PropTypes.shape({}),
  percentWatched: PropTypes.number,
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitleLines: PropTypes.number,
  subtitleText: PropTypes.string,
  target: PropTypes.string,
  titleText: PropTypes.string,
  truncateSubtitle: PropTypes.bool,
  theme: PropTypes.shape({}),
};

export default Subtitle;
